(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getTarget(cutoffHour, cutoffMinute) {
    var now = new Date();
    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMinute, 0, 0);
    var rolled = false;
    if (target.getTime() <= now.getTime()) {
      target.setDate(target.getDate() + 1);
      rolled = true;
    }
    return { target: target, rolled: rolled };
  }

  function initTimer(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var cutoffMinute = parseInt(el.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 18;
    if (isNaN(cutoffMinute)) cutoffMinute = 0;

    var hsEl = el.querySelector('[data-aurora-dispatch-hs]');
    var minEl = el.querySelector('[data-aurora-dispatch-min]');
    var segEl = el.querySelector('[data-aurora-dispatch-seg]');

    var wrapper = el.closest('.aurora-dispatch-timer');
    var whenEl = wrapper ? wrapper.querySelector('[data-aurora-dispatch-when]') : null;

    function applyLabel(rolled) {
      if (whenEl) {
        var when = rolled
          ? whenEl.getAttribute('data-when-tomorrow')
          : whenEl.getAttribute('data-when-today');
        if (when) whenEl.textContent = when;
      }
    }

    var state = getTarget(cutoffHour, cutoffMinute);

    function tick() {
      var now = new Date();
      var diff = state.target.getTime() - now.getTime();

      if (diff <= 0) {
        state = getTarget(cutoffHour, cutoffMinute);
        diff = state.target.getTime() - now.getTime();
      }

      // Se reaplica en cada tick (no solo al cruzar el corte) porque el
      // carrito puede volver a renderizar este bloque con el HTML por
      // defecto del servidor (ej. al agregar/quitar un producto) y pisar el
      // texto ya actualizado por JS; así se autocorrige en <1s.
      applyLabel(state.rolled);

      var totalSeconds = Math.max(0, Math.floor(diff / 1000));
      var hs = Math.floor(totalSeconds / 3600);
      var min = Math.floor((totalSeconds % 3600) / 60);
      var seg = totalSeconds % 60;

      if (hsEl) hsEl.textContent = pad(hs);
      if (minEl) minEl.textContent = pad(min);
      if (segEl) segEl.textContent = pad(seg);
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    var timers = document.querySelectorAll('[data-aurora-dispatch-timer]');
    timers.forEach(function (el) {
      if (el.__auroraDispatchInit) return;
      el.__auroraDispatchInit = true;
      initTimer(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
